import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const TicketBooking = () => {
  const [count, setCount] = useState(0);
  const pricePerTicket = 10;

  const navigate = useNavigate();

  const totalAmount = count * pricePerTicket;

  const handleAddToCart = () => {
    navigate('/payment2', {
      state: {
        ticketCount: count,
        total: totalAmount,
      },
    });
  };

  return (
    <div className="p-4 md:px-16">

      <div className="flex flex-col mt-6  rounded-lg shadow-lg bg-white  md:p-10 p-4  ">
      <h1 className="text-xl mb-10 font-semibold sm:text-3xl">
        Entry Ticket <span className="text-sm sm:text-lg text-[#1E1E1E] font-medium">(AED 10.00/Per Person)</span>
      </h1>

        <div className="flex flex-col md:flex-row  md:items-start">

        <div className="flex z-10 w-full md:w-fit justify-center flex-shrink-0 ">
          <img src="/zx1.jpg" className="w-full  rounded-lg shadow-lg sm:w-[400px] aspect-square object-cover " />
        </div>

        <div className="flex flex-col items-center justify-center w-full  sm:items-start  sm:px-6">
          <div className="flex items-center w-full px-2 py-4 relative  mt-2 border border-black rounded ">
          <label className="text-xs absolute -top-[12px] p-[2px] left-4 bg-white">Adults</label>
            <button
              className="flex leading-none items-center rounded-full justify-center w-8 h-8 text-white bg-[#13294B] "
              onClick={() => setCount(count > 0 ? count - 1 : 0)}
              >-</button>
            <span className="flex-1 text-lg text-center">{count}</span>
            <button
              className="flex leading-none items-center rounded-full justify-center w-8 h-8 text-white bg-[#13294B] "
              onClick={() => setCount(count + 1)}
              >+</button>
          </div>

          <p className="mt-4 text-lg text-left sm:text-left">
            Total Amount: <span>AED {totalAmount.toFixed(2)}</span>
          </p>

          <button
            onClick={handleAddToCart}
            className="w-full sm:w-44 py-3 text-lg mt-4 font-semibold text-[#13294B] bg-[#FFD367] rounded-full shadow-md text-center"
            >
            Add To Cart
          </button>
        </div>
            </div>
        <div className="mt-8 sm:mt-10 text-xs text-[#313353] text-left sm:text-left leading-relaxed">
          <span className="font-medium">
            Welcome to our section dedicated to purchasing tickets for the Sheikh Zayed Festival.
            <br className="hidden sm:block" /> Please fill in the required information and follow the steps to obtain your entry tickets.
            <br className="hidden sm:block" /> This year’s edition of the Festival features a huge variety of new cultural and entertainment
            <br className="hidden sm:block" /> events in fun exciting settings for the whole family to enjoy. These include international
            <br className="hidden sm:block" /> music concerts, rare opportunities to learn about wildlife, a selection of amazing culinary
            <br className="hidden sm:block" /> experiences from all over the world, fun competitions with valuable prizes, and much, much more.
          </span>
        </div>
      </div>

    </div>
  );
};

export default TicketBooking;
